import { connect } from 'react-redux'
import { AppState } from 'store/types'
import PremiumSwitch from './PremiumSwitch'

const mapStateToProps = ({ session }: AppState) => ({
  isPremium: session.user! && !!session.user!.info.activePremium
})

export default connect(mapStateToProps)(PremiumSwitch)
try {
    // @ts-ignore
    PremiumSwitchContainer.displayName = "PremiumSwitchContainer";
    // @ts-ignore
    PremiumSwitchContainer.__docgenInfo = { "description": "", "displayName": "PremiumSwitchContainer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PremiumSwitch/PremiumSwitchContainer.tsx#PremiumSwitchContainer"] = { docgenInfo: PremiumSwitchContainer.__docgenInfo, name: "PremiumSwitchContainer", path: "src/components/PremiumSwitch/PremiumSwitchContainer.tsx#PremiumSwitchContainer" };
}
catch (__react_docgen_typescript_loader_error) { }